import { downloadCSV } from '@helpers/downloadCSV';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { AdminUsersResponseUserDto } from 'app/API';

const headers = ['ID', 'Created', 'Name', 'Email', 'Phone', 'Organizations'];

type TAdminUserCsvData = Pick<
  AdminUsersResponseUserDto,
  'id' | 'createdAt' | 'name' | 'lastname' | 'email' | 'phone'
> & {
  organizations: Array<Pick<AdminUsersResponseUserDto['organizations'][number], 'name'>>;
};

export const downloadAdminUsersCsv = (users: TAdminUserCsvData[]) => {
  const array = users.map((data) => {
    return {
      id: data.id,
      created: getAmericanTime(data.createdAt),
      name: `${data.name} ${data.lastname}`,
      email: data.email,
      phone: data.phone,
      organizations: (data.organizations || []).map((organization) => organization.name).join(' / '),
    };
  });

  return downloadCSV(array, headers);
};
